import { PropsWithChildren } from 'react'

interface AutocallFormPropsType {}

const AutocallForm = ({ children }: PropsWithChildren<AutocallFormPropsType>) => {
  return <div className='autocall-form'>{children}</div>
}

export default AutocallForm
